<script>
// HACK: create component here, because functional components can't take local component definitions
const SortableItem = {
  name: 'SortableItem',
  inheritAttrs: false,
  props: {
    handle: {
      type: String,
      required: true
    }
  },
  methods: {
    dragstart (e) {
      e.stopPropagation()
      const contentEl = this.$el.querySelector('.content')
      const contentRect = contentEl.getBoundingClientRect()
      e.dataTransfer.setDragImage(contentEl, e.clientX - contentRect.left, e.clientY - contentRect.top)
      e.dataTransfer.setData('sortable', 'sortable')
      this.$emit('sortstart', { dragItem: this.$vnode.key })
    },
    dragenter (e) {
      if (e.dataTransfer.types.includes('sortable')) {
        e.stopPropagation()
        this.$emit('sort', { overItem: this.$vnode.key })
      }
    },
    dragend () {
      this.$emit('sortend')
    }
  },
  mounted () {
    this.$nextTick(() => {
      // dragHandle for drag start and end
      const dragHandle = this.handle ? this.$el.querySelector(this.handle) : this.$el
      dragHandle.addEventListener('dragstart', this.dragstart, true)
      dragHandle.addEventListener('dragend', this.dragend, true)
      // whole element for drag over
      this.$el.addEventListener('dragenter', this.dragenter, true)
    })
  },
  beforeDestroy () {
    // dragHandle for drag start and end
    const dragHandle = this.handle ? this.$el.querySelector(this.handle) : this.$el
    dragHandle.removeEventListener('dragstart', this.dragstart)
    dragHandle.removeEventListener('dragend', this.dragend, true)
    // whole element for drag over
    this.$el.removeEventListener('dragenter', this.dragenter)
  },
  watch: {
    handle (newHandle, oldHandle) {
      // remove old listeners
      const oldDragHandle = this.oldHandle ? this.$el.querySelector(this.oldHandle) : this.$el
      oldDragHandle.removeEventListener('dragstart', this.dragstart)
      oldDragHandle.removeEventListener('dragend', this.dragend, true)
      // add new listeners
      const newDragHandle = this.newHandle ? this.$el.querySelector(this.newHandle) : this.$el
      newDragHandle.addEventListener('dragstart', this.dragstart, true)
      newDragHandle.addEventListener('dragend', this.dragend, true)
    }
  },
  render (createElement) {
    // WARNING: This is dangerous in theory. This is a non-functional component, so it can only take one child. But since we wrap each vnode in it below, multiple root nodes can't happen.
    return this.$slots.default
  }
}

export default {
  name: 'Sortable',
  inheritAttrs: false,
  functional: true,
  props: {
    handle: {
      type: String,
      default: ''
    }
  },
  render (createElement, context) {
    function getKey (c) {
      return c.key ? c.key : getKey(c.componentOptions.children[0])
    }
    return context.children.filter(child => child.componentOptions !== undefined).map((child, i) => {
      const childKey = getKey(child)
      if (!childKey) {
        throw new Error('Children must be keyed.')
      }
      return createElement(SortableItem, {
        props: context.props,
        on: context.listeners,
        key: childKey
      }, [child])
    })
  }
}
</script>
